var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":"/img/spinner.gif"}}),_vm._v(" "),_c('p',{staticClass:"mb-0"},[_vm._t("message")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }